import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import mainPhotoDogLeft from '@assets/images/home-dog-left.webp';
import mainPhotoDogRight from '@assets/images/home-dog-right.webp';



const MainPhoto = () => {
	const { t } = useTranslation('web');

	return (
		<div className='main-photo'>
			
			<div className='main-photo-text disable-selection cats-text'>
				<p className='contact-phone-number'>{t('pages.home.cats.mainPhoto.phoneNumberLabel')} {t('shared.contactPhoneNumber')}</p>
				
				<p className='main-title'>{t('pages.home.dogs.mainPhoto.title')}</p>

				<Link to={NavigateRoutes.order} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					{t('shared.orderLongUpper')}
				</Link>

				<p className='banner-bottom-text'>{t('pages.home.dogs.mainPhoto.bannerBottomLeft')}</p>
			</div>

			<div className='main-photo-text disable-selection cats-text'>
				<p className='main-title'>{t('pages.home.dogs.mainPhoto.probeTitle')}</p>

				<Link to={NavigateRoutes.partners} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					{t('shared.orderLongUpper')}
				</Link>

				<p className='banner-bottom-text'>{t('pages.home.dogs.mainPhoto.bannerBottomRight')}</p>
			</div>
			
			<div className='main-photo-image-cats'>
				<img src={mainPhotoDogLeft} alt='main-content-photo' />
				<img src={mainPhotoDogRight} alt='main-content-photo' />
			</div>

		</div>
	);
};

export default MainPhoto;